import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { reduxForm, Field } from 'redux-form';
import * as reportConstants from '../../../constants/analytics';
import * as fetchingState from '../../../constants/fetchingState';
import CategoryClickRow from './CategoryClickRow';

let CategoryClicksTable = class extends React.Component {
    constructor (props) {
        super(props);
        this._getSortedInfo = this._getSortedInfo.bind(this);
    }

    _getSortedInfo() {
        const { categoryClicksInfo, fetching } = this.props;
        if (fetching != fetchingState.FETCHED)
            return [];

        if (!categoryClicksInfo || categoryClicksInfo.length === 0)
            return [];

        return categoryClicksInfo.sort((a, b) => {
            if (a.ClicksCount > b.ClicksCount)
                return 1;
            if (a.ClicksCount < b.ClicksCount)
                return -1;
            return 0;
        }).reverse().map((a, index) => {
            const click = {...a};
            click.Rate = index + 1;
            return click;
        });
    }

    render() {
        const { fetching } = this.props;
        const categoryClicksInfo = this._getSortedInfo();
        return (
            <div>
                <table className="table table-hover">
                    <thead>
                        {(categoryClicksInfo || categoryClicksInfo.length !== 0) && <tr>
                            <td>Рейтинг</td>
                            <td>Категория</td>
                            <td>Количество кликов</td>
                        </tr>}
                    </thead>
                    {fetching === fetchingState.FETCHING && 
                        <tr>
                            <td colSpan="7">Загрузка...</td>
                        </tr>
                    }
                    {(!categoryClicksInfo || categoryClicksInfo.length === 0) && fetching === fetchingState.FETCHED &&
                        <tr>
                            <td colSpan="7">Здесь ничего нет</td>
                        </tr>
                    }
                    {categoryClicksInfo && categoryClicksInfo.map(c => {
                        return (
                            <CategoryClickRow
                                click={c}
                                key={c.Rate} />);
                    })}
                </table>
            </div>);
    }
}

function mapToProps(state, props) {
    const formValues = getFormValues('CategoryClicksTable')(state);
    const { data, fetching } = state.application.get('reports')[reportConstants.popularClicksReport];
    return {
        formValues,
        categoryClicksInfo: data,
        fetching: fetching
    }
}

CategoryClicksTable = reduxForm({
    form: 'CategoryClicksTable'
})(CategoryClicksTable);

export default connect(mapToProps, { getFormValues })(CategoryClicksTable);


// WEBPACK FOOTER //
// ./src/components/analytics/categoryClicks/CategoryClicksTable.jsx